module.exports = __webpack_public_path__ + "static/example_1_day_timeslot_columns-5048e51365d30859133c29d48563f6d8.png";